const normalizeProxyType = (value) => {
  const normalized = String(value || "").toLowerCase();

  if (normalized === "socks4") {
    return "socks4";
  }

  if (normalized === "socks5") {
    return "socks5";
  }

  return "http";
};

export const parseWhatsappProxyLine = (raw, defaultType = "http") => {
  const trimmed = String(raw || "").trim();
  if (!trimmed) {
    return null;
  }

  let type = normalizeProxyType(defaultType);
  let body = trimmed;
  const typeMatch = trimmed.match(/\s+(socks5|socks4|http|https)\s*$/i);

  if (typeMatch) {
    type = normalizeProxyType(typeMatch[1]);
    body = trimmed.slice(0, typeMatch.index).trim();
  }

  const parts = body.split(":");
  if (parts.length < 2) {
    return null;
  }

  const host = parts[0]?.trim();
  const port = parts[1]?.trim();
  const username = parts[2]?.trim() || "";
  const password = parts.slice(3).join(":").trim() || "";

  if (!host || !port) {
    return null;
  }

  return {
    host,
    port,
    username,
    password,
    type,
    rawValue: trimmed,
  };
};

export const buildWhatsappProxyLine = ({
  host,
  port,
  username,
  password,
  type = "http",
}) => {
  if (!host || !port) {
    return "";
  }

  let value = `${host}:${port}`;

  if (username) {
    value += `:${username}:${password || ""}`;
  }

  if (type && type !== "http") {
    value += ` ${type}`;
  }

  return value;
};
